import PropTypes from 'prop-types'
import { Box, Card, IconButton, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useToast } from './Context/ToastContext'

export default function Toast({ toast }) {
  const { removeToast } = useToast()

  const Icon = toast.icon

  // Automatically dismiss notifications after 8 seconds
  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     removeToast(toast.id)
  //   }, 8000)

  //   return () => clearTimeout(timeout)
  // }, [toast.id, removeToast])

  return (
    <Card
      sx={(theme) => ({
        minWidth: 320,
        p: 2,
        bgcolor: `color-mix(in srgb, ${toast.colour} 5%, ${theme.palette.background.paper})`,
        border: '1px solid',
        borderColor: `color-mix(in srgb, ${toast.colour} 25%, transparent)`,
        borderLeft: '4px solid',
        borderLeftColor: toast.colour,
        borderRadius: 3,
      })}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: `color-mix(in srgb, ${toast.colour} 15%, transparent)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon sx={{ color: toast.colour }} />
          </Box>
          <Box>
            <Typography fontWeight={700}>{toast.title}</Typography>
            <Typography variant="body2" sx={{ mt: 0.25 }}>
              {toast.message}
            </Typography>
          </Box>
        </Box>
        <IconButton size="small" onClick={() => removeToast(toast.id)}>
          <Close fontSize="small" />
        </IconButton>
      </Box>
    </Card>
  )
}

Toast.propTypes = {
  toast: {
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    metric: PropTypes.string,
    metricLabel: PropTypes.string,
    colour: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired,
    value: PropTypes.number,
    target: PropTypes.number,
    percentage: PropTypes.number,
    hour: PropTypes.string,
    badge: PropTypes.string,
  },
}
